export default __webpack_public_path__ + "static/media/gui_background.5b7549e1.pdf";